import { API_ROUTE_SET_PHONE_NUMBER } from '@/api/apiRoutes'
import api from '@/lib/api'

interface Response {
  session_token: string
}

interface Body {
  phone_number: string
}

export const setUserPassword = async (body: Body) => {
  try {
    const { data } = await api.post<Response>(API_ROUTE_SET_PHONE_NUMBER, body)

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}
